





















import { Component, Prop, Vue } from 'vue-property-decorator'

export interface NavigationOptionProps<T> {
    label: string,
    count?: number,
    color?: string,
    active: boolean,
    hideCount?: boolean,
    value: T,
}

@Component
export default class NavigationOption extends Vue {
    @Prop({ required: true }) readonly option!: NavigationOptionProps<any>

    onClick(): void {
        this.$emit('click')
    }
}
